import {appUrl} from "../../global/helpers";

export class EshopSwitcher {
	init(params) {
		this.params = params;

		this.eGui = document.createElement('div');
		this.eGui.style.textAlign = 'center';
		this.eGui.style.width = '100%';

		var _this = this;

		var url = appUrl('admin') + '/api/v1/shops/filter?fields=id,name&isVirtual=false&isActive=true';

		if (params.company === 'brasty') {
			url = url + '&isBrasty=true';
		}
		else if (params.company === 'timestore') {
			url = appUrl('admin') + '/api/v1/shops/filter?fields=id,name&isVirtual=false&isActive=true&isTimestore=true';
		}

		if(params.onlyIds) {
			url += '&id=' + params.onlyIds
		}

		axios.get(url, {withCredentials: true})
			.then(response => {

				let html = '<span class="m-3">'
					+ '<h2>Vybrat e-shop</h2>'
					+ '<p class="my-4 mx-2">'
					+ '<select size="1" onchange="switchEshop(this.value)">';

				_.forEach(response.data, function (shop, key) {
					if (shop.value != 13) {
						if (params.idShop == shop.id) {
							html += `<option value="${shop.id}" selected>${shop.name}</option>`;
						} else {
							html += `<option value="${shop.id}">${shop.name}</option>`;
						}
					}
				});

				html += '</select>'
					+ '</p>'
					+ '</span>';

				_this.eGui.innerHTML = html;
			});

	}

	getGui() {
		return this.eGui;
	}
}

window.EshopSwitcherComponent = EshopSwitcher

export function getEshopSwitcher(shopId, company, onlyIds) {
	return [
		{
			id: 'eshopSwitcher',
			labelDefault: 'E-shop',
			labelKey: 'eshop',
			iconKey: 'colorPicker',
			toolPanel: 'eshopSwitcherComponent',
			toolPanelParams: {
				idShop: shopId,
				company: company,
        onlyIds: onlyIds
			}
		}
	];
}
